// List of college basketball teams
const collegeTeams = [
  "Abilene Christian",
  "Air Force",
  "Akron",
  "Alabama",
  "Alabama A&M",
  "Alabama State",
  "Albany",
  "Albany (NY)",
  "Alcorn State",
  "American",
  "Appalachian State",
  "Arizona",
  "Arizona State",
  "Arkansas",
  "Arkansas Little Rock",
  "Arkansas Pine Bluff",
  "Arkansas State",
  "Army",
  "Auburn",
  "Austin Peay",
  "Ball State",
  "Baylor",
  "Bellarmine",
  "Belmont",
  "Bethune-Cookman",
  "Binghamton",
  "Boise State",
  "Boston",
  "Boston College",
  "Boston University",
  "Bowling Green",
  "Bradley",
  "Brigham Young",
  "Brown",
  "Bryant",
  "Bucknell",
  "Buffalo",
  "Butler",
  "BYU",
  "Cal Baptist",
  "California",
  "California Baptist",
  "Cal Poly",
  "Cal State Bakersfield",
  "Cal State Fullerton",
  "Cal State Northridge",
  "Campbell",
  "Canisius",
  "Central Arkansas",
  "Central Connecticut State",
  "Central Michigan",
  "Charleston",
  "Charleston Southern",
  "Charlotte",
  "Chattanooga",
  "Chicago State",
  "Cincinnati",
  "Citadel",
  "Clemson",
  "Cleveland State",
  "Coastal Carolina",
  "Colgate",
  "College of Charleston",
  "Colorado",
  "Colorado State",
  "Columbia",
  "Connecticut",
  "Coppin State",
  "Cornell",
  "Creighton",
  "CSU Bakersfield",
  "CSU Fullerton",
  "CSU Northridge",
  "CSU Sacramento",
  "Dartmouth",
  "Davidson",
  "Dayton",
  "Delaware",
  "Delaware State",
  "Denver",
  "DePaul",
  "Detroit",
  "Detroit Mercy",
  "Drake",
  "Drexel",
  "Duke",
  "Duquesne",
  "East Carolina",
  "Eastern Illinois",
  "Eastern Kentucky",
  "Eastern Michigan",
  "Eastern Washington",
  "East Tennessee State",
  "Elon",
  "ETSU",
  "Evansville",
  "Fairfield",
  "Fairleigh Dickinson",
  "Fayetteville",
  "FDU",
  "FGCU",
  "FIU",
  "Florida",
  "Florida A&M",
  "Florida Atlantic",
  "Florida Gulf Coast",
  "Florida International",
  "Florida State",
  "Fordham",
  "Fresno State",
  "Furman",
  "Gardner-Webb",
  "George Mason",
  "Georgetown",
  "George Washington",
  "Georgia",
  "Georgia Southern",
  "Georgia State",
  "Georgia Tech",
  "Gonzaga",
  "Grambling State",
  "Grand Canyon",
  "Green Bay",
  "Hampton",
  "Harvard",
  "Hawaii",
  "High Point",
  "Hofstra",
  "Holy Cross",
  "Houston",
  "Houston Christian",
  "Howard",
  "Idaho",
  "Idaho State",
  "Illinois",
  "Illinois Chicago",
  "Illinois State",
  "Incarnate Word",
  "Indiana",
  "Indianapolis",
  "Indiana State",
  "Iona",
  "Iowa",
  "Iowa State",
  "IU Indianapolis",
  "IU Indy",
  "Jackson State",
  "Jacksonville",
  "Jacksonville State",
  "James Madison",
  "Kansas",
  "Kansas City",
  "Kansas State",
  "Kennesaw State",
  "Kent State",
  "Kentucky",
  "Lafayette",
  "Lamar",
  "La Salle",
  "Lehigh",
  "Le Moyne",
  "Liberty",
  "Lincoln Memorial (D2)",
  "Lindenwood",
  "Lipscomb",
  "Little Rock",
  "LIU",
  "Long Beach State",
  "Long Island",
  "Longwood",
  "Louisiana",
  "Louisiana Monroe",
  "Louisiana State",
  "Louisiana Tech",
  "Louisville",
  "Loyola Chicago",
  "Loyola Maryland",
  "Loyola Marymount",
  "Loyola (MD)",
  "LSU",
  "Maine",
  "Manhattan",
  "Marist",
  "Marquette",
  "Marshall",
  "Maryland",
  "Maryland Eastern Shore",
  "Massachusetts",
  "McNeese",
  "McNeese State",
  "Memphis",
  "Mercer",
  "Mercyhurst",
  "Merrimack",
  "Miami",
  "Miami (FL)",
  "Miami (OH)",
  "Michigan",
  "Michigan State",
  "Middle Tennessee",
  "Milwaukee",
  "Minnesota",
  "Mississippi State",
  "Mississippi Valley State",
  "Missouri",
  "Missouri State",
  "Monmouth",
  "Montana",
  "Montana State",
  "Morehead State",
  "Morgan State",
  "Mount St. Mary's",
  "MTSU",
  "Murray State",
  "Navy",
  "NC Central",
  "NC State",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Mexico",
  "New Mexico State",
  "New Orleans",
  "Niagara",
  "Nicholls State",
  "NJIT",
  "Norfolk State",
  "North Alabama",
  "North Carolina",
  "North Carolina A&T",
  "North Carolina Central",
  "North Dakota",
  "North Dakota State",
  "Northeastern",
  "Northern Arizona",
  "Northern Colorado",
  "Northern Illinois",
  "Northern Iowa",
  "Northern Kentucky",
  "North Florida",
  "North Texas",
  "Northwestern",
  "Northwestern State",
  "Notre Dame",
  "Oakland",
  "Ohio",
  "Ohio State",
  "Oklahoma",
  "Oklahoma State",
  "Old Dominion",
  "Ole Miss",
  "Omaha",
  "Oral Roberts",
  "Oregon",
  "Oregon State",
  "Pacific",
  "Penn State",
  "Pennsylvania",
  "Pepperdine",
  "Pittsburgh",
  "Portland",
  "Portland State",
  "Prairie View A&M",
  "Presbyterian",
  "Princeton",
  "Providence",
  "Purdue",
  "Purdue Fort Wayne",
  "Queens",
  "Queens (NC)",
  "Quinnipiac",
  "Radford",
  "Rhode Island",
  "Rice",
  "Richmond",
  "Rider",
  "Robert Morris",
  "Rutgers",
  "Sacramento State",
  "Sacred Heart",
  "Saint Francis",
  "Saint Francis (PA)",
  "Saint Joseph's",
  "Saint Louis",
  "Saint Mary's",
  "Saint Peter's",
  "Samford",
  "Sam Houston State",
  "San Diego",
  "San Diego State",
  "San Francisco",
  "San Jose State",
  "Santa Clara",
  "Seattle",
  "SEMO",
  "Seton Hall",
  "Siena",
  "SIUE",
  "SIU Edwardsville",
  "SMU",
  "South Alabama",
  "South Carolina",
  "South Carolina State",
  "South Dakota",
  "South Dakota State",
  "Southeastern Louisiana",
  "Southeast Missouri State",
  "Southern",
  "Southern California",
  "Southern Illinois",
  "Southern Indiana",
  "Southern Mississippi",
  "Southern Utah",
  "South Florida",
  "Stanford",
  "St. Bonaventure",
  "Stephen F. Austin",
  "Stetson",
  "St. John's",
  "St. John's (NY)",
  "St. Mary's (CA)",
  "Stonehill",
  "Stony Brook",
  "St. Thomas",
  "Syracuse",
  "Tarleton State",
  "TCU",
  "Temple",
  "Tennessee",
  "Tennessee State",
  "Tennessee Tech",
  "Texas",
  "Texas A&M",
  "Texas A&M Commerce",
  "Texas A&M Corpus Christi",
  "Texas Rio Grande Valley",
  "Texas Southern",
  "Texas State",
  "Texas Tech",
  "The Citadel",
  "Toledo",
  "Towson",
  "Troy",
  "Tulane",
  "Tulsa",
  "UAB",
  "UC Davis",
  "UCF",
  "UC Irvine",
  "UCLA",
  "UConn",
  "UC Riverside",
  "UC San Diego",
  "UC Santa Barbara",
  "UCSB",
  "UIC",
  "UL Monroe",
  "UMass",
  "UMass Lowell",
  "UMBC",
  "UMES",
  "UMKC",
  "UNC Asheville",
  "UNCG",
  "UNC Greensboro",
  "UNCW",
  "UNC Wilmington",
  "UNLV",
  "USC",
  "USC Upstate",
  "Utah",
  "Utah State",
  "Utah Tech",
  "Utah Valley",
  "UT Arlington",
  "UT Chattanooga",
  "UTEP",
  "UT Martin",
  "UTRGV",
  "UTSA",
  "Valparaiso",
  "Vanderbilt",
  "VCU",
  "Vermont",
  "Villanova",
  "Virginia",
  "Virginia Tech",
  "VMI",
  "Wagner",
  "Wake Forest",
  "Washington",
  "Washington State",
  "Weber State",
  "Western Carolina",
  "Western Illinois",
  "Western Kentucky",
  "Western Michigan",
  "West Georgia",
  "West Virginia",
  "Wichita State",
  "William & Mary",
  "Winthrop",
  "Wisconsin",
  "Wofford",
  "Wright State",
  "Wyoming",
  "Xavier",
  "Yale",
  "Youngstown State",
];

export default collegeTeams;
